/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ListCustomerSwapsRequest} from '@cash-web/protos/squareup/cash/cashliteorchestrator/api/v1beta1/orchestrator.pb'
import {ListCustomerSwapsResponse} from '@cash-web/protos/squareup/cash/cashliteorchestrator/api/v1beta1/orchestrator.pb'


export const listCustomerSwaps = (request: ListCustomerSwapsRequest, options?: CashRequestOptions) => post<ListCustomerSwapsRequest, ListCustomerSwapsResponse>("/2.0/cash/list-customer-swaps", request, {...options, rejectOnError: true })